import RatingItem from './RatingItem';

export default RatingItem;
